var Layout;
(function (Layout) {
    Layout["VARIANT_A"] = "hero--variant-a";
    Layout["VARIANT_B"] = "hero--variant-b";
})(Layout || (Layout = {}));
Object.values(Layout);
var StoryType;
(function (StoryType) {
    StoryType["EMPTY"] = "";
    StoryType["VIDEO"] = "video";
    StoryType["PODCAST"] = "podcast";
    StoryType["SLIDESHOW"] = "slideshow";
    StoryType["SERIES"] = "series";
})(StoryType || (StoryType = {}));
Object.values(StoryType);

export { Layout as L, StoryType as S };

//# sourceMappingURL=roche-story-staging-hero.types.js.map